import { apiClient } from '@/utils/api-client';

export interface Affiliate {
  id: number;
  name: string;
}

export const affiliateService = {
  async listAffiliates(): Promise<{ data: { id: string; attributes: Affiliate }[] }> {
    return apiClient.get('/api/admin/affiliates');
  },
};